export default __webpack_public_path__ + "static/media/boreal_wolfs_nostalgia.4b0076c2.png";